export default __webpack_public_path__ + "static/marqeta-docs-og-cdf5a1f563e5b1d1849c672cc0441f36.png";